document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form');
  const startAtField = document.getElementById('poster_start_at');
  const endAtField = document.getElementById('poster_end_at');
  
  if (!form || !startAtField || !endAtField) return;
  
  function validateDates() {
    const startAt = new Date(startAtField.value);
    const endAt = new Date(endAtField.value);
    
    // Remove previous error
    const existingError = endAtField.parentElement.querySelector('.date-validation-error');
    if (existingError) {
      existingError.remove();
    }
    endAtField.classList.remove('is-invalid');
    
    if (endAtField.value && startAtField.value && endAt < startAt) {
      // Add error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'invalid-feedback d-block date-validation-error';
      errorDiv.textContent = 'Дата закінчення не може бути раніше за дату початку';
      endAtField.parentElement.appendChild(errorDiv);
      endAtField.classList.add('is-invalid');
      return false;
    }
    return true;
  }
  
  endAtField.addEventListener('change', validateDates);
  startAtField.addEventListener('change', validateDates);
  
  form.addEventListener('submit', function(e) {
    if (!validateDates()) {
      e.preventDefault();
      endAtField.focus();
    }
  });
});
